import { render, staticRenderFns } from "./RoleWarningItem.vue?vue&type=template&id=63b43cb8&scoped=true"
import script from "./RoleWarningItem.vue?vue&type=script&lang=js"
export * from "./RoleWarningItem.vue?vue&type=script&lang=js"
import style0 from "./RoleWarningItem.vue?vue&type=style&index=0&id=63b43cb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b43cb8",
  null
  
)

export default component.exports